<template>
  <section class="bg-white dark:bg-gray-900 py-8 mb-12">
    <div class="flex flex-col jusitfy-center items-center container mx-auto px-4">
      <Title title="Parcours" />
      <div class="flex flex-row gap-12 mx-32 items-center w-4/5 md:w-1/2">
      
      <ol class="relative border-l border-gray-200 dark:border-gray-700 mt-8">
        <li class="mb-10 ml-6">
          <div class="absolute w-3 h-3 bg-cv rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-cv"></div>
          <time class="mb-1 text-sm font-normal leading-none text-gray-700 dark:text-gray-500">2020/2023</time>
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Bac Général</h3>
          <p class="mb-4 text-base font-normal text-gray-500 dark:text-gray-400">Get access to over 20+ pages including a dashboard layout, charts, kanban board, calendar, and pre-order <br> E-commerce & Marketing pages.</p>
          
        </li>
        <li class="mb-10 ml-6">
          <div class="absolute w-3 h-3 bg-cv rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-blue-500"></div>
          <time class="mb-1 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">2023/2026</time>
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Bachelor Communication</h3>
          <p class="text-base font-normal text-gray-500 dark:text-gray-400">All of the pages and components are first designed in Figma and we keep a parity between the two <br> versions even as we update the project.</p>
        </li>
        <li class="ml-6 mb-10">
          <div class="absolute w-3 h-3 bg-cv rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-blue-500"></div>
          <time class="mb-1 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">Février 2024</time>
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Stage Handi Val de Seine</h3>
          <p class="text-base font-normal text-gray-500 dark:text-gray-400">Get started with dozens of web components and interactive elements built <br> on top of Tailwind CSS.</p>
        </li>
        <li class="ml-6">
          <div class="absolute w-3 h-3 bg-cv rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-blue-500"></div>
          <time class="mb-1 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">Février 2024</time>
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Stage Handi Val de Seine</h3>
          <p class="text-base font-normal text-gray-500 dark:text-gray-400">Get started with dozens of web components and interactive elements built <br> on top of Tailwind CSS.</p>
        </li>
      </ol>
    </div>

    </div>
  </section>
</template>

<script>
import Title from '@/components/title.vue'

export default {
  name: 'Parcours',
  components: {
    Title
  }
}
</script>

<style scoped>
/* Ajoutez vos styles personnalisés ici */
</style>